import React, { createContext, useContext, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './Announcer.css';

const AnnouncerContext = createContext(null);

export const AnnouncerProvider = ({ children }) => {
  const politeRef = useRef(null);
  const timerRef = useRef(null);
  const counterRef = useRef(0);

  const assertiveRef = useRef(null);
  const toggleRef = useRef(false);

  const announce = (message) => {
    const node = politeRef.current;
    if (!node) return;

    clearTimeout(timerRef.current);
    counterRef.current += 1;
    const counter = counterRef.current;
    node.textContent = '';

    timerRef.current = setTimeout(() => {
      const wrapper = document.createElement('span');

      const text = document.createTextNode(message);

      const hidden = document.createElement('span');
      hidden.setAttribute('aria-hidden', 'true');
      hidden.style.display = 'none';
      hidden.textContent = counter;

      wrapper.appendChild(text);
      wrapper.appendChild(hidden);
      node.appendChild(wrapper);
    }, 250);
  };

  // Assertive announcer for action confirmations that must be heard and must
  const announceAssertive = (message) => {
    const node = assertiveRef.current;
    if (!node) return;

    toggleRef.current = !toggleRef.current;
    node.textContent = toggleRef.current ? `${message}\u00A0` : message;
  };

  return (
    <AnnouncerContext.Provider value={{ announce, announceAssertive }}>
      {children}
      <div
        ref={politeRef}
        role="status"
        aria-live="polite"
        aria-atomic="true"
        className={styles.srOnly}
      />
      <div
        ref={assertiveRef}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        className={styles.srOnly}
      />
    </AnnouncerContext.Provider>
  );
};

AnnouncerProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAnnouncer = () => {
  const ctx = useContext(AnnouncerContext);
  if (!ctx) throw new Error('useAnnouncer must be used within AnnouncerProvider');
  return ctx;
};



// WEBPACK FOOTER //
// ./src/client/Components/Announcer/Announcer.js